import { Link } from 'react-router-dom';
import { TwitterLogo, InstagramLogo, FacebookLogo } from '@phosphor-icons/react';

const links = {
  Product: [
    { label: 'Features', href: '/#features' },
    { label: 'How it Works', href: '/#how-it-works' },
    { label: 'FAQ', href: '/#faq' },
    { label: 'iOS App', href: 'https://apps.apple.com/gb/app/inked/id6761901067', internal: false },
    { label: 'Android App', href: 'https://play.google.com/store/apps/details?id=fit.inked.inked', internal: false },
  ],
  Company: [
    { label: 'Contact', href: '#contact' },
    { label: 'Admin Sign In', href: 'https://app.inked.fit/login', internal: false },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '/privacy', internal: true },
    { label: 'Terms of Service', href: '/terms', internal: true },
  ],
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 px-6 lg:px-8 pt-14 pb-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 mb-12">

          {/* Brand */}
          <div className="md:col-span-4 space-y-4">
            <img src="/logo.png" alt="Inked" className="h-7 w-auto" />
            <p
              className="text-sm text-gray-500 leading-relaxed max-w-xs"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Attendance tracking at lightning speed. Built for organisations that value their time and members.
            </p>
            {/* Socials */}
            <div className="flex gap-3 pt-1">
              {[
                { href: 'https://x.com/inked_fit', Icon: TwitterLogo, label: 'Twitter' },
                { href: 'https://www.instagram.com/lnked.fit', Icon: InstagramLogo, label: 'Instagram' },
                { href: 'https://www.facebook.com/share/1AGZJQDhFE/', Icon: FacebookLogo, label: 'Facebook' },
              ].map(({ href, Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center text-gray-400 hover:text-gray-700 hover:border-gray-300 transition-colors"
                >
                  <Icon size={15} weight="fill" />
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          <div className="md:col-span-8 grid grid-cols-3 gap-8">
            {Object.entries(links).map(([heading, items]) => (
              <div key={heading}>
                <p
                  className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-4"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {heading}
                </p>
                <ul className="space-y-3">
                  {items.map(({ label, href, internal }) => (
                    <li key={label}>
                      {internal ? (
                        <Link
                          to={href}
                          className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
                          style={{ fontFamily: 'Manrope, sans-serif' }}
                        >
                          {label}
                        </Link>
                      ) : (
                        <a
                          href={href}
                          className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
                          style={{ fontFamily: 'Manrope, sans-serif' }}
                        >
                          {label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p
            className="text-xs text-gray-400"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            © {year} Inked.fit. All rights reserved.
          </p>
          <p
            className="text-xs text-gray-300"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            Designed &amp; built with care.
          </p>
        </div>
      </div>
    </footer>
  );
}
